import React, { useEffect, useRef, useState, FC } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useScmSaleSoDetailModel } from "../scmSaleSoModel";
import useGlobalModel from "@/model/globalModel";

export const FormBox: FC<RouterParamType> = ({ }) => {
    const formRef = useRef<IYhFormRef>();
    const { fetchCustomerList, beShopDs } = useGlobalModel();

    const {
        lookSoFormVal,
        resetLookCatch,
        getSaleRoDetailOne,
    } = useScmSaleSoDetailModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮 
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id } = detailsInfo
    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        getSaleRoDetailOne(id)
    }, [id]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            resetLookCatch()
        }
    }, [selectedNavId])


    // 销售单基础信息
    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",

        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售单号",
                fieldName: "saleCode",
                disable: true,
                placeholder: "自动生成"
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '客户名称',
                fieldName: "customerName",
                placeholder: "客户名称",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单下浮",
                fieldName: "discountRate",
                rules: [{ required: true, message: "该项为必填" }, { pattern: /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/, message: '请输入0-1' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "应收金额",
                fieldName: "totalAmount",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售类型",
                fieldName: "saleTypeName",
                // onSelectChange: saleTypeChange,
                // options: getSelectedDictOne(DictCodeEnmu.SALE_TYPE),
                rules: [{ required: true, message: "请选销售类型" }],
                // disable: mode === "edit" ? true : !!addGoodsList.length
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单优惠",
                fieldName: "favorableAmount",
                rules: [{ pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "已收金额",
                fieldName: "receivedAmount",
                disable: true,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售单位",
                fieldName: "bentityName",
                rules: [{ required: true, message: "请选择销售单位" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "手机号",
                fieldName: "phone",
                rules: [{ required: true, message: "该项为必填项" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠总额",
                fieldName: "discountTotalAmount",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "售价选择",
                fieldName: "priceTypeName",
                rules: [{ required: true, message: "请选择售价类型" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "客户类型",
                fieldName: "customerTypeName",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货地址",
                fieldName: "deliveryAddress",
                span: 12,
                labelCol: { span: 3 },
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "品牌",
                fieldName: "brandName",
                rules: [{ required: true, message: "请选择配件品牌" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "从属门店",
                fieldName: "shopName",
                disable: true,

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 10,
                labelCol: { span: 4 },
                colClassName: "detail-note-col",
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "none",
                span: 2,
                labelCol: { span: 16, offset: 8 },
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "优惠类型",
                fieldName: "preferentialTypeName",
                allowClear: true,
                rules: [{ required: true, message: "该项为必填项" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "厂家单号",
                fieldName: "wcCode",
                disable: true,
                hidden: more

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务员",
                fieldName: "operator",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "casher",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管",
                fieldName: "storekeeper",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算日期",
                fieldName: "settleTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结款日期",
                fieldName: "payTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出库日期",
                fieldName: "stockIoTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单日期",
                fieldName: "createTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改日期",
                fieldName: "updateTime",
                hidden: more,
                disable: true,
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型code",
                fieldName: "customerTypeCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "品牌名称",
                fieldName: "brandName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售类型名称",
                fieldName: "saleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择名称",
                fieldName: "priceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型名称",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售单位名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠类型名称",
                fieldName: "preferentialTypeName",
                hidden: true
            }
        ]
    };

    const poFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: lookSoFormVal,
        // onChange,
        disabled: true,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}